/** 与后端 {@code online.fromzwr.support.sse.SseEventNames} 保持一致 */
export const SSE_EVENT_COMIC_EPISODE_JOB_UPDATED = 'job_updated' as const

export const SSE_EVENT_CREATION_TASK_UPDATED = 'task_updated' as const

export const SSE_EVENT_WORKFLOW_RUN_UPDATED = 'workflow_run_updated' as const
